export * from './FilterSearchPageHeading';
